import { Vue, Component, Ref, Prop } from 'vue-property-decorator'
import { IDENTIFIER_SCOPES } from '@/api/resources/identifierScopesResource'
import patientResource from '@/api/resources/PatientResource'
import { initialScanWidgetState, ScanWidgetPatientResourceService, ScanWidgetState } from '@/modules/dashboardModule/widgets/scan-widget/scan-widget.models'
import ModalRepeatedPatients from '@/modules/RegistryModule/views/editCase/modals/ModalRepeatedPatients.vue'
import { PAGINATOR_BIG_PAGE_SIZE } from '@/shared/services/services-constants'
import { PATIENT_IDENTIFIER_CODES } from '@/api/resources/IdentifierRegexesService'

export interface ScanWidgetItem {
    subType: string
    disabled: boolean
}

@Component({
    components: { ModalRepeatedPatients }
})
export default class ScanWidget extends Vue {
    @Prop() item!: ScanWidgetItem;
    state: ScanWidgetState
    patientResource: ScanWidgetPatientResourceService = patientResource
    @Ref('modalRepeatedPatients') modalRepeatedPatients!: any

    constructor() {
        super()
        this.state = initialScanWidgetState()
    }

    get regex(): any {
        return this.$store.getters.regex
    }

    get isCaseSubtype(): boolean {
        return this.item.subType === 'case'
    }

    get isRequestSubtype(): boolean {
        return this.item.subType === 'request'
    }

    onCloseButton() {
        this.$emit('hideItemLayout')
    }

    openWidgetConfigurationSidepanel() {
        this.$emit('openWidgetConfigurationSidepanel', true)
    }

    newCase() {
        for (let regex of this.regex) {
            const regexObj = new RegExp('^(?:' + regex.regex + ')$')
            const searchTrim = this.state.caseSearchModel.trim()
            if (regexObj.test(searchTrim)) {
                if (regex.identifierType.idtScope === IDENTIFIER_SCOPES.PERSON) {
                    this.loadPatient(searchTrim)
                    return
                }

                if (regex.identifierType.idtScope === IDENTIFIER_SCOPES.CENTER_PATIENT) {
                    this.loadPatient(searchTrim)
                    return
                }
            } else {
                if (this.state.caseSearchModel) {
                    this.$_showErrorModal(this.$t('dashboard.errorMessages.invalidPatientId') as string)
                }
                break
            }
        }
    }

    newRequest() {
        for (let regex of this.regex) {
            const regexObj = new RegExp('^(?:' + regex.regex + ')$')
            const searchTrim = this.state.requestSearchModel.trim()
            if (regexObj.test(searchTrim)) {
                if (regex.identifierType.idtScope === IDENTIFIER_SCOPES.PERSON) {
                    this.loadPatientRequest(searchTrim)
                    return
                }

                if (regex.identifierType.idtScope === IDENTIFIER_SCOPES.CENTER_PATIENT) {
                    this.loadPatientRequest(searchTrim)
                    return
                }
            } else {
                if (this.state.requestSearchModel) {
                    this.$_showErrorModal(this.$t('dashboard.errorMessages.invalidPatientId') as string)
                }
                break
            }
        }
    }

    async loadPatient(id: string) {
        const [err, response] = await this.$_toCall(this.patientResource.paginator({
            size: PAGINATOR_BIG_PAGE_SIZE,
            id: id,
            identifierType: PATIENT_IDENTIFIER_CODES.NIF
        }), true)
        if (err) {
            return
        }

        if (response.content.length > 1) {
            this.modalRepeatedPatients.show([response.content, id])
        } else if (response.content.length === 1) {
            this.showPatient(response.content[0])
        } else {
            this.$_showErrorModal(this.$t('dashboard.errorMessages.noPatientFound', { identifier: 'NIF' }) as string)
        }
    }

    onModalRepeatedPatientsSelected(patient: any) {
        if (this.isRequestSubtype) {
            this.$router.push({ name: 'newRequest', params: { patientId: patient.patId } })
        } else {
            this.showPatient(patient)
        }
    }

    showPatient(patient: any) {
        this.$router.push({ name: 'newCase', params: { patId: patient.patId } })
    }

    async loadPatientRequest(id: string) {
        const [err, response] = await this.$_toCall(this.patientResource.paginator({
            size: PAGINATOR_BIG_PAGE_SIZE,
            id: id,
            identifierType: PATIENT_IDENTIFIER_CODES.NIF
        }), true)
        if (err) {
            return
        }

        if (response.content.length > 1) {
            this.modalRepeatedPatients.show([response.content, id])
        } else if (response.content.length === 1) {
            this.$router.push({ name: 'newRequest', params: { patientId: response.content[0].patId } })
        } else {
            this.$_showErrorModal(this.$t('dashboard.errorMessages.noPatientFound', { identifier: 'NIF' }) as string)
        }
    }
}
